import { useTranslation } from 'react-i18next';
import useHorizontalCarousel from "../Compartido/useHorizontalCarousel";
import CabeceraSeccion from './CabeceraSeccion.jsx';
import ControlesSlider from './ControlesSlider.jsx';

// Notícies del blog de BedLoop, amb les targetes del disseny. Només surt
// si n'hi ha.
const NoticiasHome = ({ noticias, ruta, lang, elementosweb }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const { trackRef, navState, scrollByCard } = useHorizontalCarousel('.c-card', noticias.length);

    if (noticias.length === 0) return null;

    return (
        <section className="offers o-container">
            <CabeceraSeccion
                antetitulo={t("Diario de viaje")}
                titulo={elementosweb.cabecera_buscador ? elementosweb.cabecera_buscador[lang] : t("Blog")}
                texto={"<p>" + t("Eventos, guias, trucos, noticias y más...") + "</p>"}
                boton={{ href: "/" + preidioma + t("blog"), label: t("Más propuestas") }}
            />
            <div className="c-cards-list c-cards-list--bedloop" ref={trackRef}>
                {noticias.map((noticia, index) => {
                    const href = "/" + preidioma + t("blog") + "/" + noticia.laurl;
                    const imagen = noticia.imagen != ""
                        ? ruta + "/blog/" + noticia.id + "/" + noticia.imagen
                        : "/images/web/bedloop-nofoto.png";
                    return (
                        <article className="c-card c-card--with-price" key={index}>
                            <div className="c-card__header">
                                <a href={href} className="hc-noticia__media" style={{ "--hc-noticia-fons": "url(\"" + imagen + "\")" }}>
                                    <img className="image-cover" alt={noticia.eltitulo} title={noticia.eltitulo} src={imagen} loading="lazy" />
                                </a>
                            </div>
                            <div className="c-card__body">
                                <div className="c-card__content">
                                    <span className="c-card__date">{noticia.fecha_publica}</span>
                                    <h3 className="c-card__title">{noticia.eltitulo}</h3>
                                    <div className="c-card__desc" dangerouslySetInnerHTML={{ __html: noticia.ladesc }}></div>
                                </div>
                                <div className="c-card__footer">
                                    <a href={href} className="c-link">{t("leer más")}</a>
                                </div>
                            </div>
                        </article>
                    );
                })}
            </div>
            {!(navState.atStart && navState.atEnd) && (
                <ControlesSlider
                    onPrev={() => scrollByCard(-1)}
                    onNext={() => scrollByCard(1)}
                    prevDisabled={navState.atStart}
                    nextDisabled={navState.atEnd}
                />
            )}
        </section>
    );
};

export default NoticiasHome;
